import { render, staticRenderFns } from "./LoginControls.vue?vue&type=template&id=2c6ea9dd&"
import script from "./LoginControls.vue?vue&type=script&lang=js&"
export * from "./LoginControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/aalzahr/mwc-components-common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6ea9dd')) {
      api.createRecord('2c6ea9dd', component.options)
    } else {
      api.reload('2c6ea9dd', component.options)
    }
    module.hot.accept("./LoginControls.vue?vue&type=template&id=2c6ea9dd&", function () {
      api.rerender('2c6ea9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoginForm/LoginControls.vue"
export default component.exports